import { FC } from 'react';
import { Tag, TagColors, useTranslation } from '@packages/utils';
import { EEventStatus } from 'data/types/events.types';

export type TEventStatusProps = {
  text?: EEventStatus;
  className?: string;
};

const EventStatus: FC<TEventStatusProps> = ({ text, className }) => {
  const { t } = useTranslation({
    keyPrefix: 'enums.event-status',
  });
  const eventStatusColorMapper: Record<EEventStatus, TagColors> = {
    [EEventStatus.PLANNING]: 'primary',
    [EEventStatus.CANCELLED]: 'danger',
    [EEventStatus.PUBLISHED]: 'success',
    [EEventStatus.CLOSED]: 'purple',
    [EEventStatus.RESCHEDULED]: 'pink',
  };

  if (!text) return null;
  return (
    <Tag className={className} color={eventStatusColorMapper[text]}>
      {t(text)}
    </Tag>
  );
};

export default EventStatus;
